import React from 'react';
import ReactDOM from 'react-dom/client';
import Routes from './routes';
import SolanaWalletProvider from './components/SolanaWallet/SolanaWalletProvider';
import './mobile-responsive.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SolanaWalletProvider>
      <Routes />
    </SolanaWalletProvider>
  </React.StrictMode>
);
